<template>
    <div ref="costAnalysisDetail" class="bill-dashboard">
        <!-- Pending 상태일 때 전체를 덮는 placeholder -->
        <div v-if="dataStatus === 'pending'" class="data-empty-placeholder">
            <div class="empty-content">
                <div class="empty-icon">
                    <i class="fas fa-inbox"></i>
                </div>
                <div class="empty-text">데이터가 없습니다</div>
                <div class="empty-subtext">선택한 기간에 해당하는 데이터가 존재하지 않습니다</div>
            </div>
        </div>
        <!-- 청구 총액 강조 섹션 -->
        <!-- <div class="total-amount-section">
            <div class="amount-label">이번 달 청구 금액</div>
            <div class="amount-value">{{ formatNumber(getBillInfo?.totalAmount) }}원</div>
            <div class="amount-detail">
                <span class="unit-price">1kWh당 {{ formatNumber(getBillInfo?.unitPrice) }}원</span>
            </div>
        </div> -->
        <div v-else style="overflow-y: auto; padding: 8px 0 0 0">
            <!-- 상단: 1행 3열 레이아웃 -->
            <div class="top-section-layout">
                <!-- 1열: 계약 및 추가 정보 카드 -->
                <div class="col-1-card minStyle">
                    <div class="customer-info-panel">
                        <h3 class="bill-panel-title">
                            <!-- <i class="fas fa-user"></i> -->
                            요금 및 계약
                        </h3>
                        <div class="info-grid">
                            <div class="info-item">
                                <label>고객번호</label>
                                <span class="value">{{ getCustomerInfo?.custNo || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>계량기 번호</label>
                                <select v-model="selectedMeter" class="meter-select">
                                    <option :value="null">전체</option>
                                    <option v-for="item in meterNoList" :value="item" :key="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="info-item">
                                <label>요금타입</label>
                                <span class="value"
                                    >{{ getCustomerInfo?.contractType || "-" }}
                                    <span class="customer-sub-label">
                                        (
                                        {{
                                            getCustomerInfo?.currentMeter
                                                ? `선택${getCustomerInfo?.currentMeter?.sel_cost ?? "-"}`
                                                : `선택${getCustomerInfo?.meters?.[0]?.sel_cost ?? "-"}`
                                        }})
                                    </span></span
                                >
                            </div>
                            <div class="info-item">
                                <label>계약 전력</label>
                                <span class="value">{{ getCustomerInfo?.contractPower || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>단위 금액</label>
                                <span class="value"
                                    >{{ getBillInfo?.unitPrice ? getBillInfo.unitPrice.toFixed(1) : "-" }} 원/kWh</span
                                >
                            </div>
                            <div class="info-item" v-if="getCustomerInfo">
                                <label>검침일</label>
                                <span class="value">
                                    {{
                                        getCustomerInfo?.currentMeter
                                            ? `${getCustomerInfo?.currentMeter?.mr_ymd ?? "-"}일`
                                            : `${getCustomerInfo?.meters?.[0]?.mr_ymd ?? "-"}일`
                                    }}
                                </span>
                            </div>

                            <div class="info-item" v-if="getCustomerInfo">
                                <label>계기 역률</label>
                                <span class="value">
                                    {{
                                        getCustomerInfo?.currentMeter
                                            ? `${getCustomerInfo?.currentMeter?.pwrfact ?? "-"}%`
                                            : `${getCustomerInfo?.meters?.[0]?.pwrfact ?? "-"}%`
                                    }}
                                </span>
                            </div>
                            <div
                                class="info-item"
                                v-if="getBillInfo?.jiPwrfact !== undefined || getBillInfo?.jnPwrfact !== undefined"
                            >
                                <label>역률 (지상/진상)</label>
                                <span class="value">
                                    {{ getBillInfo?.jiPwrfact || "-" }}% / {{ getBillInfo?.jnPwrfact || "-" }}%
                                </span>
                            </div>
                            <div class="info-item" v-if="getBillInfo?.billAplyPwr !== undefined">
                                <label>적용 피크</label>
                                <span class="value">{{ formatNumber(getBillInfo?.billAplyPwr || 0) }} kW</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 2열: 고지서 카드 -->
                <div class="col-2-card minStyle">
                    <div class="bill-card-wrapper" v-if="currentBillData">
                        <div class="bill-card receipt-card">
                            <!-- 고객 정보 -->
                            <div class="receipt-card-customer">
                                <div class="receipt-card-customer-name">{{ getCustomerInfo?.customerName || "-" }}</div>
                                <div class="receipt-card-customer-info" v-if="getCustomerInfo">
                                    <span>고객번호: {{ getCustomerInfo.custNo }}</span>
                                    <span v-if="getCustomerInfo.billYearMonth">청구월: {{ getCustomerInfo.billYearMonth }}</span>
                                    <span v-if="usagePeriodLabel">사용기간: {{ usagePeriodLabel }}</span>
                                </div>
                            </div>

                            <!-- 총 청구 금액 -->
                            <div class="receipt-detail-row receipt-detail-total">
                                <span class="receipt-detail-label">
                                    총 청구 요금 <span class="receipt-formula">(①+②+③+④-⑤)</span>
                                    <span
                                        v-if="getBillInfo?.isPredicted"
                                        class="prediction-badge-inline"
                                        :title="`예측 방식: ${getPredictionMethodText}`"
                                    >
                                        <i class="fas fa-chart-line"></i> 예측
                                    </span>
                                </span>
                                <span class="receipt-detail-value"
                                    >{{ formatBillTotalAmount(getBillInfo?.totalAmount || 0) }}
                                </span>
                            </div>

                            <!-- 청구 상세 내역 (영수증 스타일) -->
                            <div class="receipt-card-details">
                                <div class="receipt-details-inner">
                                    <div class="receipt-power-bill-section">
                                        <div class="receipt-detail-row receipt-detail-subtotal">
                                            <span class="receipt-detail-label">
                                                <span class="receipt-plus">+</span>
                                                청구전력요금 <span class="receipt-formula">(①+②+③)</span>
                                            </span>
                                            <span class="receipt-detail-value"
                                                >{{ formatNumber(getBillInfo?.reqBill || 0) }}원</span
                                            >
                                        </div>
                                        <div class="receipt-power-bill-group">
                                            <div class="receipt-detail-row receipt-detail-item">
                                                <span class="receipt-detail-label">
                                                    <span class="receipt-number-circle">①</span>
                                                    기본요금
                                                </span>
                                                <span class="receipt-detail-value"
                                                    >{{ formatNumber(getBillInfo?.baseBill || 0) }}원</span
                                                >
                                            </div>
                                            <div class="receipt-detail-row receipt-detail-item">
                                                <span class="receipt-detail-label">
                                                    <span class="receipt-number-circle">②</span>
                                                    전력량요금
                                                </span>
                                                <span class="receipt-detail-value"
                                                    >{{ formatNumber(getBillInfo?.kwhBill || 0) }}원</span
                                                >
                                            </div>
                                            <div class="receipt-detail-row receipt-detail-item">
                                                <span class="receipt-detail-label">
                                                    <span class="receipt-number-circle">③</span>
                                                    기타요금
                                                </span>
                                                <span class="receipt-detail-value">
                                                    {{ formatNumber(calculateOtherBill()) }}원
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="receipt-detail-row receipt-detail-tax">
                                        <span class="receipt-detail-label">
                                            <span class="receipt-plus">+</span>
                                            <span class="receipt-number-circle">④</span>
                                            부가세 및 전력기금
                                        </span>
                                        <span class="receipt-detail-value">
                                            {{ formatNumber(calculateTaxAndFund()) }}원
                                        </span>
                                    </div>
                                    <div class="receipt-detail-row receipt-detail-discount">
                                        <span class="receipt-detail-label">
                                            <span class="receipt-minus">-</span>
                                            <span class="receipt-number-circle">⑤</span>
                                            할인요금
                                        </span>
                                        <span class="receipt-detail-value"
                                            >{{ formatNumber(getBillInfo?.discountBill || 0) }}원</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 3열: 6개월간 요금 추이 차트 -->
                <div class="col-3-card minStyle">
                    <div class="trend-chart-card">
                        <h3 class="bill-panel-title">
                            <!-- <i class="fas fa-chart-line"></i> -->
                            청구 요금 추이
                        </h3>
                        <div class="trend-chart-content">
                            <BillMonthlyTrendChart :data="getBillTrend" :selectedPeriod="selectedPeriod" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 차트 및 분석 섹션 -->
            <div class="analysis-section">
                <div class="detailed-analysis-tabs">
                    <div class="analysis-tabs-header">
                        <b-tabs nav-class="analysis-tab-nav" pills v-model="activeTab" @input="onTabChange">
                            <b-tab title="사용량 분석" :active="activeTab === 0">
                                <div class="analysis-panel">
                                    <div class="chart-container">
                                        <BillDailyUsageChart
                                            :data="getTrendData?.data"
                                            :activeTab="activeTab"
                                            :selectedPeriod="selectedPeriod"
                                        />
                                    </div>
                                    <div class="table-container">
                                        <BillDailyUsageTable
                                            :data="getTrendData?.data"
                                            :selectedPeriod="selectedPeriod"
                                        />
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="소비 패턴 분석" :active="activeTab === 1">
                                <div class="load-analysis-panel">
                                    <div class="heatmap-section">
                                        <BillLoadSectionHeatmap
                                            :data="costData"
                                            :selectedPeriod="selectedPeriod"
                                            :activeTab="activeTab"
                                        />
                                    </div>
                                    <div class="table-section">
                                        <BillLoadCostChart
                                            :data="getLoadSectionCostRatio?.chartData"
                                            :activeTab="activeTab"
                                        />
                                        <BillLoadSectionTable
                                            :data="getLoadSectionCostRatio?.tableData"
                                            :billInfo="getBillInfo"
                                        />
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BillMonthlyTrendChart from "./BillMonthlyTrendChart.vue";
import BillDailyUsageChart from "./BillDailyUsageChart.vue";
import BillLoadCostChart from "./BillLoadCostChart.vue";
import BillDailyUsageTable from "./BillDailyUsageTable.vue";
import BillLoadSectionTable from "./BillLoadSectionTable.vue";
import BillLoadSectionHeatmap from "./BillLoadSectionHeatmap.vue";
import backEndApi from "@api/backEndApi.js";
import html2pdf from "html2pdf.js";

export default {
    name: "BillMain",
    components: {
        BillMonthlyTrendChart,
        BillDailyUsageChart,
        BillLoadCostChart,
        BillDailyUsageTable,
        BillLoadSectionTable,
        BillLoadSectionHeatmap,
    },
    props: {
        custNo: {
            type: String,
            default: null,
        },
        selectedPeriod: {
            type: String,
            default: "monthly",
        },
        currentYear: {
            type: Number,
            default: () => new Date().getFullYear(),
        },
        currentMonth: {
            type: Number,
            default: () => new Date().getMonth() - 1,
        },
        dataStatus: {
            type: String,
            default: "active",
        },
    },
    mounted() {
        this.initData();
    },

    watch: {
        custNo() {
            // 고객 번호가 변경되면 계량기 번호를 전체로 초기화
            this.selectedMeter = null;
            const regDt = this.getDate(this.selectedPeriod);
            this.getCostData(regDt, null);
        },
        selectedMeter(newVal) {
            const regDt = this.getDate(this.selectedPeriod);
            this.getCostData(regDt, newVal);
        },
        // 연/월/기간 변경은 regDtKey를 기준으로 한 번만 감지해서 API 호출
        regDtKey(newVal) {
            this.getCostData(newVal, this.selectedMeter);
        },
        getBillInfo: {
            handler(newVal) {
                if (newVal) {
                    this.$emit("update-summary", {
                        totalAmount: newVal.totalAmount || 0,
                        totalUsage: newVal.totalUsage || 0,
                        unitPrice: newVal.unitPrice || 0,
                    });
                }
            },
            immediate: true,
        },
    },
    computed: {
        getCustomerInfo() {
            if (!this.costData) return null;
            return this.costData?.customerInfo;
        },
        getBillInfo() {
            if (!this.costData) return null;
            return this.costData?.billInfo;
        },
        usagePeriodLabel() {
            const p = this.costData?.usagePeriod;
            if (!p?.startDate || !p?.endDate) return "";
            const fmt = (ymd) => {
                if (!ymd || String(ymd).length < 8) return ymd;
                const s = String(ymd);
                return `${s.substring(0, 4)}-${s.substring(4, 6)}-${s.substring(6, 8)}`;
            };
            return `${fmt(p.startDate)} ~ ${fmt(p.endDate)}`;
        },
        getBillTrend() {
            if (!this.costData) return null;
            return this.costData?.billTrend;
        },
        getTrendData() {
            if (!this.costData) return null;
            return this.costData?.usageTrend;
        },
        // getDailyMonthlyTrend() {
        //     if (!this.costData) return null;
        //     return this.costData?.dailyMonthlyTrend;
        // },
        getLoadSectionCostRatio() {
            if (!this.costData) return null;
            return this.costData?.loadSectionCostRatio;
        },
        // 현재 선택된 연/월/기간을 기반으로 한 API 조회 키
        regDtKey() {
            return this.getDate(this.selectedPeriod);
        },
        // DatePicker computed 속성들
        currentDateDisplay() {
            return `${this.currentYear}년 ${this.currentMonth + 1}월`; // 0-11을 1-12로 변환
        },
        currentYearDisplay() {
            return `${this.currentYear}년`;
        },
        yearRange() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = currentYear - 5; i <= currentYear + 5; i++) {
                years.push(i);
            }
            return years;
        },
        isNavigationDisabled() {
            // 필요에 따라 네비게이션 비활성화 조건 추가
            return false;
        },
        getPredictionMethodText() {
            if (!this.getBillInfo?.predictionMethod) return "";

            const methodMap = {
                period_data_based: "기간 데이터 기반",
                historical_average: "과거 평균 기반",
                trend_analysis: "추세 분석 기반",
                ml_model: "머신러닝 모델",
            };

            return methodMap[this.getBillInfo.predictionMethod] || this.getBillInfo.predictionMethod;
        },
        currentBillData() {
            if (!this.getCustomerInfo || !this.getBillInfo) return null;
            return {
                custNm: this.getCustomerInfo.customerName,
                custNo: this.getCustomerInfo.custNo,
                contractInfo: {
                    ictg: this.getCustomerInfo.contractType,
                    ikw: this.getCustomerInfo.contractPower,
                },
                totalUsage: this.getBillInfo.totalUsage,
                unitPrice: this.getBillInfo.unitPrice,
                totalAmount: this.getBillInfo.totalAmount,
                billDetails: {
                    baseBill: this.getBillInfo.baseBill,
                    kwhBill: this.getBillInfo.kwhBill,
                    reqBill: this.getBillInfo.reqBill,
                    discountBill: this.getBillInfo.discountBill,
                },
            };
        },
        getBillTrendComparison() {
            if (!this.getBillTrend || !this.getBillTrend.data || this.getBillTrend.data.length < 2) {
                return null;
            }

            const data = this.getBillTrend.data;
            const current = data[data.length - 1];
            const previous = data[data.length - 2];

            if (!current || !previous) return null;

            const currentAmount = current.totalReqAmt || 0;
            const previousAmount = previous.totalReqAmt || 0;
            const currentUsage = current.totalUsage || 0;
            const previousUsage = previous.totalUsage || 0;
            const currentUnitPrice = currentUsage > 0 ? currentAmount / currentUsage : 0;
            const previousUnitPrice = previousUsage > 0 ? previousAmount / previousUsage : 0;
            const currentReqBill = this.getBillInfo?.reqBill || 0;
            const previousReqBill = previousAmount || 0;

            return {
                amountChange: currentAmount - previousAmount,
                amountChangePercent: previousAmount > 0 ? ((currentAmount - previousAmount) / previousAmount) * 100 : 0,
                usageChange: currentUsage - previousUsage,
                usageChangePercent: previousUsage > 0 ? ((currentUsage - previousUsage) / previousUsage) * 100 : 0,
                unitPriceChange: currentUnitPrice - previousUnitPrice,
                unitPriceChangePercent:
                    previousUnitPrice > 0 ? ((currentUnitPrice - previousUnitPrice) / previousUnitPrice) * 100 : 0,
                reqBillChange: currentReqBill - previousReqBill,
                reqBillChangePercent:
                    previousReqBill > 0 ? ((currentReqBill - previousReqBill) / previousReqBill) * 100 : 0,
            };
        },
    },
    data() {
        return {
            costData: null,
            meterNoList: [],
            selectedMeter: null,
            activeTab: 0, // 현재 활성 탭 인덱스
            // 이전 값 저장용 (에러 시 롤백용)
            previousYear: new Date().getFullYear(),
            previousMonth: new Date().getMonth() - 1,
        };
    },
    methods: {
        formatBillTotalAmount(value) {
            const num = Number(value);
            if (isNaN(num)) return "-";

            const abs = Math.abs(num);
            // 1억 미만: 원 단위 그대로 (예: 53,250원)
            if (abs < 100000000) {
                return Math.round(abs).toLocaleString("ko-KR") + "원";
            }

            // 1억 이상: 만 원 미만 절사 후 억/만 표기
            let remaining = Math.floor(abs / 10000) * 10000;
            const units = ["", "만", "억", "조", "경"];
            const parts = [];
            let unitIndex = 0;

            while (remaining > 0) {
                const chunk = remaining % 10000;
                if (chunk > 0) {
                    parts.unshift(`${chunk.toLocaleString("ko-KR")}${units[unitIndex]}`);
                }
                remaining = Math.floor(remaining / 10000);
                unitIndex++;
            }

            return (parts.length ? parts.join(" ") : "0") + " 원";
        },
        formatLargeNumber(value) {
            const num = Number(value);

            if (isNaN(num)) {
                return { value: "", unit: "" };
            }

            // 1조(1,000,000,000,000) 이상이면 조 단위로 표시
            if (num >= 1000000000000) {
                const roundedValue = Math.round(num / 1000000000000); // 소수점 없이 정수로 표시
                return {
                    value: roundedValue.toLocaleString("ko-KR"),
                    unit: "조",
                };
                // 1억(100,000,000) 이상이면 억 단위로 표시
            } else if (num >= 100000000) {
                const roundedValue = Math.round(num / 100000000); // 소수점 없이 정수로 표시
                return {
                    value: roundedValue.toLocaleString("ko-KR"),
                    unit: "억",
                };
            } else {
                return {
                    value: num.toLocaleString("ko-KR"),
                    unit: "",
                };
            }
        },
        formatNumber(value) {
            const num = Number(value);
            return isNaN(num) ? "" : num.toLocaleString();
        },
        async getCostData(regDt, meterNo) {
            try {
                let { data, status } = await backEndApi.kepco.analyzeUsageCost(
                    regDt || null,
                    meterNo || null,
                    this.custNo || null
                );
                if (status !== 200) {
                    throw new Error(data.message);
                }
                this.costData = data.data;

                // 데이터 상태 및 메시지 업데이트
                this.$emit("update-data-status", data.data?.status || "active");
                this.$emit("update-status-message", data.data?.message || "");

                // 데이터를 받은 후 계량기 번호 리스트 업데이트
                this.processCostData();
            } catch (error) {
                this.alertWarning(`${error}`);
                // 에러 발생 시 DatePicker 값을 이전 값으로 롤백
                this.rollbackDatePicker();
                this.alertWarning(`${error}`);
            }
        },
        getDate(type) {
            // const today = new Date();
            const year = this.currentYear;
            const month = String(this.currentMonth + 1).padStart(2, "0"); // 0-11을 1-12로 변환
            if (type === "monthly") {
                return `${year}${month}`;
            } else if (type === "yearly") {
                return `${year}`;
            }
        },
        async initData() {
            const regDt = this.getDate(this.selectedPeriod);
            await this.getCostData(regDt);

            this.processCostData();
        },
        calculateOtherBill() {
            const baseBill = Number(this.getBillInfo?.baseBill || 0);
            const kwhBill = Number(this.getBillInfo?.kwhBill || 0);
            const reqBill = Number(this.getBillInfo?.reqBill || 0);
            return Math.max(0, reqBill - baseBill - kwhBill);
        },
        calculateTaxAndFund() {
            const totalAmount = Number(this.getBillInfo?.totalAmount || 0);
            const reqBill = Number(this.getBillInfo?.reqBill || 0);
            const discountBill = Number(this.getBillInfo?.discountBill || 0);
            return Math.max(0, totalAmount - reqBill + discountBill);
        },
        processCostData() {
            // 계량기 번호 리스트 초기화 후 새로 채우기
            this.meterNoList = [];
            if (this.costData && this.costData.customerInfo && this.costData.customerInfo.meterNo) {
                this.costData.customerInfo.meterNo.forEach((item) => {
                    this.meterNoList.push(item);
                });
            }

            // 임시 전력 지표 데이터 추가
            if (!this.costData.powerIndicators) {
                this.costData.powerIndicators = {
                    midLoad: 1250.5,
                    maxLoad: 1850.2,
                    maxDemand: 2100.8,
                    leadingPowerFactor: 95.2,
                    laggingPowerFactor: 88.7,
                };
            }

            // 임시 일별/월별 데이터에 전력 지표 추가
            if (this.costData.usageTrend && this.costData.usageTrend.data) {
                this.costData.usageTrend.data.forEach((item) => {
                    item.midLoad = (1200 + Math.random() * 200).toFixed(1);
                    item.maxLoad = (1800 + Math.random() * 300).toFixed(1);
                    item.maxDemand = (2000 + Math.random() * 400).toFixed(1);
                    item.leadingPowerFactor = (90 + Math.random() * 10).toFixed(1);
                    item.laggingPowerFactor = (85 + Math.random() * 10).toFixed(1);
                });
            }

            // 임시 부하구간별 데이터에 전력 지표 추가
            if (this.costData.loadSectionCostRatio && this.costData.loadSectionCostRatio.tableData) {
                this.costData.loadSectionCostRatio.tableData.forEach((item) => {
                    item.avgMidLoad = (1000 + Math.random() * 500).toFixed(1);
                    item.avgMaxLoad = (1500 + Math.random() * 800).toFixed(1);
                    item.avgMaxDemand = (1800 + Math.random() * 1000).toFixed(1);
                    item.avgLeadingPowerFactor = (88 + Math.random() * 12).toFixed(1);
                    item.avgLaggingPowerFactor = (82 + Math.random() * 15).toFixed(1);
                });
            }
        },
        onTabChange(tabIndex) {
            this.activeTab = tabIndex;
        },
        // DatePicker 관련 메서드들
        toggleDatePicker() {
            this.showDatePicker = !this.showDatePicker;
        },
        // DatePicker 값 저장 및 롤백 메서드들
        saveCurrentDate() {
            this.previousYear = this.currentYear;
            this.previousMonth = this.currentMonth;
        },
        rollbackDatePicker() {
            this.$emit("rollback-date", {
                year: this.previousYear,
                month: this.previousMonth,
            });
        },
        exportPDF() {
            const element = this.$refs.costAnalysisDetail;
            if (!element) return;

            // PDF 생성 전에 header-right 영역 숨기기
            const headerRight = element.querySelector(".header-right");
            if (headerRight) {
                headerRight.style.display = "none";
            }

            const date = this.selectedPeriod === "monthly" ? this.currentDateDisplay : this.currentYearDisplay;

            const opt = {
                margin: 10,
                filename: `전기요금 고지서_${date}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "mm", format: [500, 297], orientation: "landscape" },
            };

            html2pdf()
                .set(opt)
                .from(element)
                .save()
                .then(() => {
                    // PDF 생성 완료 후 header-right 영역 다시 보이기
                    if (headerRight) {
                        headerRight.style.display = "flex";
                    }
                });
        },
    },
};
</script>

<style scoped>
.customer-sub-label {
    color: #64748b;
    font-weight: 400;
    font-size: 11px;
}
.minStyle {
    min-width: 100% !important;
}

.dropdown-icon-container {
    width: 20%;
    display: flex;
    justify-content: center;
}

/* 기본 스타일 리셋 */
label {
    margin-bottom: 0px !important;
}

/* 메인 컨테이너 */
.bill-dashboard {
    color: #1e293b;
    padding: 0;
    height: 100%;
    border-radius: 8px;
    position: relative;
}

/* 고지서 헤더 */
.bill-header {
    background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
    color: white;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
}

.header-left {
    position: relative;
    z-index: 1;
    display: flex;
    gap: 12px;
}

.back-btn {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-right: 12px;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateX(-2px);
}

.bill-title {
    font-size: 24px;
    font-weight: 800;
    margin: 0px !important;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: -0.5px;
}

.bill-period {
    font-size: 14px;
    font-weight: 500;
    opacity: 0.9;
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 16px;
    display: inline-block;
    backdrop-filter: blur(10px);
}

.header-right {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 1;
}

.period-toggle {
    display: flex;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 2px;
    backdrop-filter: blur(10px);
}

.toggle-btn {
    padding: 6px 12px;
    background: transparent;
    color: rgba(255, 255, 255, 0.8);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
    position: relative;
}

.toggle-btn:focus {
    outline: none;
}

.toggle-btn.active {
    background: rgba(255, 255, 255, 0.3);
    color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.toggle-btn:hover:not(.active) {
    background: rgba(255, 255, 255, 0.1);
    color: white;
}

.pdf-btn {
    padding: 6px 12px;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    gap: 4px;
}

.pdf-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* 청구 총액 강조 섹션 */
.total-amount-section {
    /* flex: 1; */
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.total-amount-section-container {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 20px;
    padding: 14px;
}

.amount-label {
    font-size: 14px;
    color: #bdbdbd;
    font-weight: 600;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.divider-line {
    width: 2px;
    background: linear-gradient(to bottom, transparent 0%, #cbd5e1 20%, #cbd5e1 80%, transparent 100%);
    margin: 0;
}

.amount-unit-value {
    font-size: 24px;
    color: #1e293b;
    font-weight: 800;
    margin-bottom: 0;
    letter-spacing: 0.3px;
    text-shadow: 0 1px 2px rgba(30, 64, 175, 0.1);
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.detail-body-unit {
    font-size: 11px;
    color: #616161;
    font-weight: 600;
    margin-bottom: 2px;
    letter-spacing: 0.5px;
    margin-left: 2px;
}

.amount-value-unit {
    font-size: 14px;
    color: #616161;
    font-weight: 600;
    /* margin-bottom: 8px; */
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.amount-value {
    font-size: 30px;
    font-weight: 900;
    color: #1e40af;
    margin-bottom: 0;
    text-shadow: 0 2px 4px rgba(30, 64, 175, 0.1);
    line-height: 1.1;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.amount-detail {
    font-size: 11px;
    color: #64748b;
    font-weight: 600;
}

.amount-value-unit {
    /* margin-top: 8px; */
    display: flex;
    justify-content: center;
}

.unit-price {
    background: #3b82f6;
    color: white;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(59, 130, 246, 0.2);
    letter-spacing: 0.3px;
}

/* 정보 섹션 */
.bill-body {
    max-width: 100%;
    margin: 0;
}

.bill-header-section {
    background: white;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bill-company-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.bill-company-name {
    font-size: 24px;
    font-weight: 900;
    color: #1e40af;
    letter-spacing: -0.5px;
}

.bill-company-subtitle {
    font-size: 14px;
    font-weight: 600;
    color: #64748b;
}

.bill-header-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: right;
}

.bill-number,
.bill-date {
    font-size: 12px;
    color: #64748b;
    font-weight: 500;
}

.info-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
    margin: 0 0 8px 0;
}

.customer-info-panel,
.billing-detail-panel,
.trend-chart-panel {
    background: white;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.right-section .trend-chart-panel {
    flex: 1;
    min-height: 500px;
}

.customer-info-panel:hover,
.billing-detail-panel:hover,
.trend-chart-panel:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
    height: 85%;
}

.billing-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
}

.total-width {
    width: 70%;
}

.unit-width {
    width: 30%;
}

.billing-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* align-items: center; */
    padding: 12px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
}

.billing-item:hover {
    background: #f1f5f9;
    transform: translateY(-1px);
}

.billing-item.primary {
    border-left: 3px solid #3b82f6;
}

.billing-item.discount {
    border-left: 3px solid #10b981;
    background: #f0fdf4;
}

.billing-item.total {
    border-left: 3px solid #ea3f3f;
    background: #fdf2f0;
}

.billing-item.discount:hover {
    background: #ecfdf5;
}

.billing-item label {
    font-size: 12px;
    font-weight: 600;
    color: #bdbdbd;
    margin: 0;
}

.billing-item .value {
    font-size: 14px;
    font-weight: 800;
    color: #1e293b;
}

.billing-item.discount .value {
    color: #059669;
}

/* 분석 섹션 */
.analysis-section {
    margin: 0 0 8px 0;
    gap: 8px;
    flex: 1;
    min-height: 400px;
}

::v-deep .tabs {
    height: 100%;
    width: 100%;
}

::v-deep .tab-content {
    height: calc(100% - 50px);
}

::v-deep .tab-pane {
    height: 100%;
}

.analysis-tabs-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.detailed-analysis-tabs {
    background: white;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
    height: 100%;
}

.analysis-tab-nav {
    background: #f8fafc;
    border-radius: 8px;
    padding: 4px;
    /* margin-bottom: 26px; */
    border: 1px solid #e2e8f0;
    font-family: "Roboto Slab";
}

.analysis-tab-nav .nav-link {
    color: #64748b;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-weight: 600;
    font-size: 12px;
    transition: all 0.3s ease;
    position: relative;
}

.analysis-tab-nav .nav-link.active {
    background: #3b82f6;
    color: white;
    box-shadow: 0 1px 4px rgba(59, 130, 246, 0.3);
}

.analysis-tab-nav .nav-link:hover:not(.active) {
    background: #e2e8f0;
    color: #1e293b;
}

.analysis-panel {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 16px;
    min-height: 330px;
    margin-top: 16px;
    height: 100%;
}

.chart-container {
    background: #f8fafc;
    border-radius: 8px;
    padding: 12px;
    /* border: 1px solid #e2e8f0; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.table-container {
    /* display: flex;
    flex-direction: column; */
    height: 100%;
}

/* 부하 구간별 분석 패널 */
.load-analysis-panel {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 16px;
    min-height: 300px;
    margin-top: 16px;
}

.heatmap-section {
    background: #f8fafc;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
}

.table-section {
    background: #f8fafc;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
}

.heatmap-container {
    /* margin-top: 16px; */
    background: #f8fafc;
    border-radius: 8px;
    /* padding: 12px; */
    /* border: 1px solid #e2e8f0; */
}

/* 날짜 선택기 */
.date-picker-container {
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 0;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    min-width: 250px;
    z-index: 9999;
    backdrop-filter: blur(10px);
}

.nav-btn {
    background: none;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    color: #64748b;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.nav-btn:hover:not(:disabled) {
    color: #3b82f6;
    background: #f1f5f9;
}

.nav-btn:focus {
    outline: none;
}

.nav-btn:disabled {
    color: #cbd5e1;
    cursor: not-allowed;
}

.date-display {
    flex: 1;
    /* padding: 8px 12px; */
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 120px;
    border-left: 1px solid #e2e8f0;
    border-right: 1px solid #e2e8f0;
    transition: all 0.2s ease;
}

.date-display:hover {
    background: #f8fafc;
}

.date-text {
    font-size: 14px;
    font-weight: 900;
    color: #1e293b;
    display: flex;
    justify-content: center;
    width: 80%;
}

.dropdown-icon {
    font-size: 10px;
    color: #64748b;
    transition: transform 0.2s ease;
}

.date-display:hover .dropdown-icon {
    transform: translateY(1px);
}

.date-picker-container .dropdown-icon.open {
    transform: rotate(180deg);
}

.date-picker-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    margin-top: 6px;
    padding: 16px;
    min-width: 240px;
}

/* 월 선택기 스타일 */
.month-picker {
    width: 100%;
}

.year-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
}

.year-nav-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 4px 8px;
    cursor: pointer;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s ease;
    font-weight: 600;
    font-size: 12px;
}

.year-nav-btn:focus {
    outline: none;
}

.year-nav-btn:hover {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
}

.year-display {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
}

.month-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
}

.month-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 8px 4px;
    cursor: pointer;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    transition: all 0.2s ease;
    text-align: center;
}

.month-btn:hover {
    background: #e2e8f0;
    border-color: #cbd5e1;
    color: #1e293b;
}

.month-btn.active {
    background: #3b82f6;
    border-color: #3b82f6;
    color: white;
    box-shadow: 0 1px 4px rgba(59, 130, 246, 0.3);
}

/* 연도 선택기 스타일 */
.year-picker {
    width: 100%;
}

.year-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    max-height: 160px;
    overflow-y: auto;
}

.year-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 8px 4px;
    cursor: pointer;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    transition: all 0.2s ease;
    text-align: center;
}

.year-btn:hover {
    background: #e2e8f0;
    border-color: #cbd5e1;
    color: #1e293b;
}

.year-btn.active {
    background: #3b82f6;
    border-color: #3b82f6;
    color: white;
    box-shadow: 0 1px 4px rgba(59, 130, 246, 0.3);
}

/* 예측 배지 스타일 */
.prediction-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    padding: 4px 10px;
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    color: white;
    font-size: 11px;
    font-weight: 600;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.prediction-badge i {
    font-size: 10px;
}

/* 상단 레이아웃 - 1행 3열 */
.top-section-layout {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
    margin-bottom: 12px;
}

.col-1-card,
.col-2-card,
.col-3-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    min-height: 0;
}

.col-3 {
    height: 100%;
}

/* 하단 1열 레이아웃 */
.bottom-section-layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 12px;
}

.info-card,
.billing-card,
.trend-chart-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.trend-chart-card .bill-panel-title {
    margin: 0 0 12px 0;
    padding: 0 0 8px 0;
    /* border-bottom: 2px solid #3b82f6; */
    font-family: "Roboto Slab";
}

.info-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.info-card-title i {
    color: #3b82f6;
    font-size: 12px;
}

.info-card-content,
.billing-card-content {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 0;
    overflow-y: auto;
}

.contract-info-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.info-subtitle {
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
}

.contract-info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.contract-info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.info-label {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
}

.info-value {
    font-size: 13px;
    color: #1e293b;
    font-weight: 700;
}

.additional-info-section-new {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.additional-info-grid-new {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
}

.additional-info-item-new {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
}

.additional-info-item-new label {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.additional-info-item-new .value {
    font-size: 12px;
    font-weight: 700;
    color: #1e293b;
}

.stats-grid-new {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.stat-card-new {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    transition: all 0.2s ease;
}

.stat-card-new:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
}

.stat-label-new {
    font-size: 11px;
    color: #64748b;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-value-new {
    font-size: 18px;
    color: #1e293b;
    font-weight: 700;
}

.stat-value-new.primary {
    color: #3b82f6;
    font-size: 20px;
}

.trend-chart-content {
    flex: 1;
    padding: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}

.trend-chart-content ::v-deep .chart-container {
    flex: 1;
    min-height: 0;
    height: 100% !important;
    width: 100%;
    position: relative;
}

/* 고객 정보 패널 (계약 및 추가 정보용) */
.bill-panel-title {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 12px 0;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 8px;
    font-family: "Roboto Slab";
    /* border-bottom: 2px solid #3b82f6; */
}

.bill-panel-title i {
    color: #3b82f6;
    font-size: 14px;
}

.customer-info-panel .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 8px;
    flex: 1;
    min-height: 0;
}

.info-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
}

.info-item:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.info-item label {
    font-size: 12px;
    font-weight: 600;
    color: #bdbdbd;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
}

.info-item .value {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
}

.info-item .meter-select {
    padding: 6px 8px;
    background: white;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    cursor: pointer;
    width: 100%;
    margin-top: 4px;
}

.info-item .meter-select:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.bill-card-wrapper {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.bill-card.receipt-card {
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
}

/* 고객 정보 */
.receipt-card-customer {
    padding: 12px 16px;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
    background: #f1f5f9;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.receipt-card-customer-name {
    font-size: 15px;
    font-weight: 800;
    color: #1e293b;
    margin-bottom: 4px;
}

.receipt-card-customer-info {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: #64748b;
    font-weight: 500;
    margin: 0;
}

/* 계약 정보 */
.receipt-card-contract {
    padding: 10px 16px;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    background: white;
}

.receipt-card-contract-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
}

.receipt-label {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
    margin: 0;
}

.receipt-value {
    font-size: 11px;
    color: #1e293b;
    font-weight: 700;
    margin: 0;
}

/* 청구 상세 내역 (영수증 스타일) */
.receipt-card-details {
    padding: 0;
    margin: 0;
    background: white;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-radius: 0 0 8px 8px;
}

.receipt-details-inner {
    padding: 10px 16px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.receipt-detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    font-size: 14px;
}

.receipt-power-bill-group {
    padding-left: 16px;
    border-left: 2px solid #e2e8f0;
    background: #f8fafc;
    border-radius: 4px;
    margin-top: 4px;
}

.receipt-detail-row.receipt-detail-item {
    border-bottom: none;
    margin-bottom: 0;
}

.receipt-detail-label {
    color: #64748b;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
}

.receipt-detail-value {
    color: #1e293b;
    font-weight: 700;
    text-align: right;
}

.receipt-plus,
.receipt-minus {
    display: inline-block;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    border-radius: 2px;
}

.receipt-plus {
    color: #059669;
    background: #d1fae5;
}

.receipt-minus {
    color: #dc2626;
    background: #fee2e2;
}

.receipt-number-circle {
    display: inline-block;
    font-size: 14px;
    color: #1e40af;
    font-weight: 700;
    margin-right: 4px;
}

.receipt-formula {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
    margin-left: 4px;
}

.receipt-detail-subtotal .receipt-detail-label,
.receipt-detail-subtotal .receipt-detail-value {
    font-weight: 800;
    color: #1e40af;
}

.receipt-detail-discount .receipt-detail-value {
    color: #dc2626;
}

.receipt-detail-tax {
    padding: 0;
    margin-top: 4px;
    margin-bottom: 4px;
}

.receipt-detail-total {
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
    padding: 6px 16px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
}

.receipt-detail-total .receipt-detail-label {
    font-size: 15px;
    font-weight: 900;
    color: #1e40af;
}

.receipt-detail-total .receipt-detail-value {
    font-size: 24px;
    font-weight: 900;
    color: #1e40af;
}

.prediction-badge-inline {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: 8px;
    padding: 2px 8px;
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    color: white;
    font-size: 10px;
    font-weight: 600;
    border-radius: 10px;
    vertical-align: middle;
}

.prediction-badge-inline i {
    font-size: 9px;
}

/* 계량기 선택 섹션 */
.meter-select-section {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.meter-select-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
    white-space: nowrap;
}

.meter-select-section .meter-select {
    flex: 1;
    padding: 6px 12px;
    background: white;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    cursor: pointer;
}

.meter-select-section .meter-select:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* 추가 정보 섹션 */
.additional-info-section {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.info-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 12px 0;
    padding-bottom: 8px;
    border-bottom: 2px solid #3b82f6;
}

.additional-info-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
}

.additional-info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
}

.additional-info-item label {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.additional-info-item .value {
    font-size: 12px;
    font-weight: 700;
    color: #1e293b;
}

/* 통계 그리드 (2x2) */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    flex-shrink: 0;
}

.stat-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    transition: all 0.2s ease;
}

.stat-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
}

.stat-label {
    font-size: 11px;
    color: #64748b;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-value {
    font-size: 20px;
    color: #1e293b;
    font-weight: 700;
}

.stat-value.primary {
    color: #3b82f6;
    font-size: 22px;
}

.stat-change {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
}

.stat-change-value {
    font-size: 12px;
    font-weight: 700;
}

.stat-change-value.positive {
    color: #dc2626;
}

.stat-change-value.negative {
    color: #059669;
}

.stat-change-label {
    font-size: 10px;
    color: #94a3b8;
    font-weight: 500;
}

/* 데이터 없음 placeholder */
.data-empty-placeholder {
    height: 100%;
    bottom: 0;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 40px;
}

.empty-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    border-radius: 50%;
    color: #94a3b8;
    font-size: 36px;
}

.empty-text {
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: 0.3px;
}

.empty-subtext {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    text-align: center;
    line-height: 1.5;
}
</style>
